import React, { useState, useEffect, useRef } from 'react';
import '../css/custom.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';
import '../css/vending.css';
import { FormContainer } from './FormContainer';
import VendingService from '../services/VendingService';
import ResponseParser from '../util/ResponseParser';
import DataTable from './DataTable';
import Modal from './Modal';
import ModalReceipt from './ModalReceipt';
import { FaPrint } from 'react-icons/fa';
import { useReactToPrint } from 'react-to-print';

export const TokenReprint = (props) => {
   const { match } = props;
   const id = match.params.transactionId;
   const [isLoading, setIsLoading] = useState(false);
   const [errors, setErrors] = useState([]);
   const [receipt, setReceipt] = useState({});
   const [isModalActive, setIsModalActive] = useState(false);
   const [receiptData, setReceiptData] = useState([]);
   const componentRef = useRef();

   const [transactionId, setTransactionId] = useState('');

   const columns = [
      {
         columnCaption: 'Buyer Identifier',
         columnKey: 'buyeridentifier',
      },
      {
         columnCaption: 'Names',
         columnKey: 'names',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'amount',
      },
      {
         columnCaption: 'Status',
         columnKey: 'status',
         content: (item) => {
            if (item.status === 'SALE COMPLETED')
               return <span className='tag is-link is-light'>{item.status}</span>;
            else return <span className='tag is-danger is-light'>{item.status}</span>;
         },
      },
      {
         columnCaption: 'Time',
         columnKey: 'datetime',
      },
      {
         columnCaption: 'Action',
         content: (item) => {
            if (item.status === 'SALE COMPLETED')
               return (
                  <>
                     <span className='is-size-6 mr-3' onClick={() => showModal(item)}>
                        <FaPrint />
                     </span>
                     {/* <span className='is-size-6 mr-3' onClick={() => showModal(item, 'send-sms')}>
                        <FaSms />
                     </span> */}
                  </>
               );
         },
      },
   ];

   useEffect(() => {
      if (id) {
         setTransactionId(id);
      } else {
         setTransactionId('');
      }
   }, [id]);

   const printComponent = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: `Receipt-${receipt.receiptNumber}`,
      copyStyles: true,
   });

   const showModal = (selectedItem) => {
      setIsModalActive(true);
   };
   const cancelModal = (e) => {
      e.preventDefault();
      setIsModalActive(false);
   };

   const renderTokenReceipt = () => {
      return (
         <>
            {/* <Receipt title={'Token Receipt'} tokenReceipt={state.tokenReceipt} /> */}
            <ModalReceipt tokenReceipt={receipt} />
         </>
      );
   };

   const handlePrint = () => {
      setIsModalActive(false);
      printComponent();
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      setIsLoading(true);
      const partnerId = 1102;
      VendingService.getReceiptWithoutLogin({
         partnerId,
         transactionId: transactionId,
      })
         .then((resp) => resp.text())
         .then((data) => {
            let response = ResponseParser.parseTokenReceiptResponse(data);
            if (response) {
               const {
                  meterNumber,
                  firstName,
                  purchaseAmount,
                  receiptTime,
                  receiptNumber,
                  units,
               } = response;
               const reponseList = [
                  {
                     transactionId,
                     buyeridentifier: meterNumber,
                     names: firstName,
                     amount: purchaseAmount,
                     receiptNumber,
                     status: 'SALE COMPLETED',
                     datetime: receiptTime,
                     units: units,
                  },
               ];
               setReceiptData(reponseList);
               setReceipt(response);
               setIsLoading(false);
            }
            // setReceiptData.push({ ...response });
            console.log(response);
         })
         .catch((error) => {
            console.error(error);
         });
   };
   return (
      <FormContainer sizeColumn={'is-6'}>
         <h2 className='subtitle is-4 mb-3'>Transaction #: {transactionId}</h2>
         <form onSubmit={handleSubmit}>
            <div className='field'>
               {/* <label className='label'>Transaction Id</label> */}
               <div className='control'>
                  <input
                     className='input'
                     name='transactionId'
                     type='text'
                     value={transactionId}
                     onChange={(e) => setTransactionId(e.target.value)}
                     placeholder='Transaction Id'
                  />
               </div>
            </div>
            <div>
               <button
                  type='submit'
                  className={`button is-link is-fullwidth ${isLoading ? 'is-loading' : ''} mb-5`}
               >
                  Get Token
               </button>
            </div>
            {errors.map((error) => {
               return <div className='error-message'>{error}</div>;
            })}
         </form>
         <DataTable items={receiptData} pageSize={20} columns={columns} />
         <Modal
            modalTitle={''}
            isModalActive={isModalActive}
            actionCancel={cancelModal}
            actionSubmit={handlePrint}
            buttonLabel={'Print'}
            // selectedItem={selectedItem}
            isLoading={isLoading}
         >
            {renderTokenReceipt()}
         </Modal>
         <div style={{ display: 'none' }}>
            <ModalReceipt tokenReceipt={receipt} ref={componentRef} />
         </div>
      </FormContainer>
   );
};
